import styles from './index.module.scss'
import styles2 from '../index.module.scss'
import { useState, useEffect } from 'react'
import { Table, Divider, Popover, Pagination, message, Badge } from 'antd'
import PSAIModal from '@PSAIComponents/PSAIModal';
import Utils from '@utils/utils'
import wechat from '@assets/images/svgIcon/wechat.svg'
import Alipay from '@assets/images/svgIcon/Alipay.svg'
import TabCom from '../hooks/TabCom'
import TopWrap from '../hooks/TopWrap';
import API from '@api/api';

const titleList = [
    { label: '订单记录', key: 'orderRecord' },
    { label: '套餐记录', key: 'packageRecord' }
];

const PersonalOrder = () => {
    const [activeIndex, setActiveIndex] = useState('orderRecord');
    const [orderLoading, setOrderLoading] = useState(false);

    const [orderPageIndex, setOrderPageIndex] = useState(1);
    const [comboPageIndex, setComboPageIndex] = useState(1);
    const pageSize = 20;

    const [orderList, setOrderList] = useState([]);
    const [comboList, setComboList] = useState([]);

    const comboColumns = [
        { title: '订单编号', key: 'tradeId', dataIndex: 'tradeId', ellipsis: true, width: 200 },
        { title: '服务内容', key: 'subject', dataIndex: 'subject', ellipsis: true },
        { title: '虹豆总量', dataIndex: 'powerAmount', key: 'powerAmount', ellipsis: true },
        {
            key: 'powerAmountUsed',
            title: '已用虹豆',
            ellipsis: true,
            render: (record) => record.powerAmount - record.powerBalance,
        },
        { title: '余额', dataIndex: 'powerBalance', key: 'powerBalance', ellipsis: true },
        {
            key: 'status',
            title: '可用状态',
            ellipsis: true,
            render: (record) =>
                record.status == 0 ? (
                    <span style={{ color: '#006EFF' }}>
                        <Badge status="processing" /> 生效中
                    </span>
                ) : record.status == 1 ? (
                    <span style={{ color: '#5B6673' }}>已失效</span>
                ) : (
                    <span style={{ color: '#006EFF' }}>已升级</span>
                ),
        },
        { title: '生效时间', dataIndex: 'effectiveTime', key: 'effectiveTime', ellipsis: true },
        { title: '失效时间', dataIndex: 'expiredTime', key: 'expiredTime', ellipsis: true },
        {
            title: '操作',
            key: 'action',
            width: 150,
            fixed: 'right',
            render: (_, record) =>
                record.status == 'created' ? (
                    <span style={{ color: '#006EFF', cursor: 'pointer' }}>取消订单</span>
                ) : (
                    <Popover
                        placement="top"
                        content={
                            <>
                                <img
                                    style={{ width: '120px', height: '120px' }}
                                    src={Utils.qrcodeSales}
                                    alt="扫码联系我们"
                                />
                                <p style={{ textAlign: 'center' }}>客服微信</p>
                            </>
                        }
                    >
                        <span style={{ color: '#006EFF', cursor: 'pointer' }} >
                            开发票
                        </span>
                    </Popover>
                ),
        }
    ];

    const orderColumns = [
        { title: '订单编号', key: 'tradeId', dataIndex: 'tradeId', ellipsis: true, width: 250 },
        { title: '服务内容', key: 'subject', dataIndex: 'subject', ellipsis: true },
        { title: '订单金额', key: 'dealAmount', dataIndex: 'dealAmount', ellipsis: true },
        {
            title: '订单状态',
            key: 'status',
            dataIndex: 'status',
            ellipsis: true,
            render: (text, record) => {
                if (text == 'created') return <span style={{ cursor: 'pointer', color: '#FF8D29' }}>待支付</span>;
                else if (text == 'closed') return <span style={{ color: '#FF3B30' }}>已关闭</span>;
                else if (text == 'success') return <span>已完成</span>;
                else if (text == 'failed') return <span style={{ color: '#96A2B1' }}>失败</span>;
                else if (text == 'admin') return <span>已分配</span>;
            },
        },
        { title: '下单时间', key: 'orderTime', dataIndex: 'orderTime', ellipsis: true },
        {
            title: '操作',
            key: 'action',
            width: 150,
            fixed: 'right',
            render: (_, record) =>
                record.status == 'created' ? (
                    <span style={{ color: '#006EFF', cursor: 'pointer' }}>取消订单</span>
                ) : (
                    <Popover
                        placement="top"
                        content={
                            <>
                                <img
                                    style={{ width: '120px', height: '120px' }}
                                    src={Utils.qrcodeSales}
                                    alt="扫码联系我们"
                                />
                                <p style={{ textAlign: 'center' }}>客服微信</p>
                            </>
                        }
                    >
                        <span style={{ color: '#006EFF', cursor: 'pointer' }}>
                            开发票
                        </span>
                    </Popover>
                ),
        },
    ];

    // Tab 切换时重置页码
    const handleClick = (path) => {
        setActiveIndex(path);
        if (path === 'orderRecord') setOrderPageIndex(1);
        else setComboPageIndex(1);
    };

    // 分页切换
    const pageChange = (pageNumber) => {
        if (activeIndex === 'orderRecord') setOrderPageIndex(pageNumber);
        else setComboPageIndex(pageNumber);
    };

    // 获取订单记录
    const getOrderList = () => {
        setOrderLoading(true);
        API.getOrderList({})
            .then((res) => {
                if (res.code == 0) {
                    setOrderList(res.data || []);
                } else {
                    message.error(res.message);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setOrderLoading(false);
            });
    };

    // 获取套餐记录
    const getMembershipList = () => {
        setOrderLoading(true);
        API.getMembershipList({})
            .then((res) => {
                if (res.code == 0) {
                    setComboList(res.data || []);
                } else {
                    message.error(res.message);
                }
            })
            .finally(() => {
                setOrderLoading(false);
            });
    };

    useEffect(() => {
        getOrderList();
        getMembershipList();
    }, []);

    return (
        <div className={styles.personalOrder}>
            <TopWrap />
            <div className={styles2.tableWrap}>
                <TabCom items={titleList} getActiveIndex={handleClick} />

                {activeIndex === 'orderRecord' ? (
                    <Table
                        className="personalTable"
                        loading={orderLoading}
                        rowKey="tradeId"
                        pagination={false}
                        scroll={{
                            x: 'max-content',
                            y: `calc(100vh - 580px)`,
                        }}
                        columns={orderColumns}
                        dataSource={orderList.slice((orderPageIndex - 1) * pageSize, orderPageIndex * pageSize)}
                    />
                ) : (
                    <Table
                        className="personalTable"
                        loading={orderLoading}
                        rowKey="tradeId"
                        pagination={false}
                        scroll={{
                            x: 'max-content',
                            y: `calc(100vh - 580px)`,
                        }}
                        columns={comboColumns}
                        dataSource={comboList.slice((comboPageIndex - 1) * pageSize, comboPageIndex * pageSize)}
                    />
                )}

                {(activeIndex === 'orderRecord' ? orderList.length > 0 : comboList.length > 0) && (
                    <div className={styles2.PaginationWarp}>
                        <Pagination
                            showQuickJumper
                            total={activeIndex === 'orderRecord' ? orderList.length : comboList.length}
                            onChange={pageChange}
                            pageSize={pageSize}
                            current={activeIndex === 'orderRecord' ? orderPageIndex : comboPageIndex}
                            showSizeChanger={false}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default PersonalOrder;
